// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2WBTT","Overlay":"Modal_Overlay__2AxMb","HeroImage":"Modal_HeroImage__ANlxd","Close":"Modal_Close__1coF5","description":"Modal_description__bEp23"};